module.exports = new __parcel__URL__("Design Sprint.261d030b.svg").toString();